// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__NV6zy","filesListContainer":"PosDisputesFiles_filesListContainer__1p5fC","filesButton":"PosDisputesFiles_filesButton__mActk"};